import { render, staticRenderFns } from "./HistoryTableItem.vue?vue&type=template&id=0a6ddb60&scoped=true&"
import script from "./HistoryTableItem.vue?vue&type=script&lang=js&"
export * from "./HistoryTableItem.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTableItem.vue?vue&type=style&index=0&id=0a6ddb60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6ddb60",
  null
  
)

export default component.exports